// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"4e26122c","169":"f88fe7c0","799":"a434d358","943":"0a1d404d","956":"dc91732a","968":"f07bdf27"}[chunkId] + ".chunk.js";
};